<template>
  <div class="toggleLabelContainer" :title="name">
    <img class="iconSource" :src="getIconSrc" @error="imageLoadError" />
    <label class="iconLabel" v-if="name">
      {{ name }}
    </label>
  </div>
</template>

<script>
export default {
  /**
   * Name of the component
   */
  name: 'ToggleLabel',

  /**
   * This components properties
   */
  props: {
    name: String,
    id: String,
    iconSrc: String,
  },

  /**
   * Computed methods
   */
  computed: {
    getIconSrc() {
      return this.iconSrc ? this.iconSrc : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    },
  },

  /**
   * Component methods
   */
  methods: {
    /**
     * Error handling for the image
     */
    imageLoadError(event) {
      event.target.src = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    },
  },
}
</script>
<style lang="postcss" scoped>
.toggleLabelContainer {
  @apply relative flex items-center;
  right: 15px;
}
.iconSource {
  @apply w-5 h-5;
}
.iconLabel {
  @apply text-sm flex-grow truncate;
  margin-left: 10px;
}
</style>
